module.exports = "#toTop{\n\tposition: fixed;\n\tbottom: 10px;\n\tright: 10px;\n\tcursor: pointer;\n\tdisplay: none;\n}"